import { Clock } from 'lucide-react';
import { useVisit } from '../../VisitContext';

export function VisitTimeInOut() {
	const { timeIn, timeOut } = useVisit();

	const visitLengthInMinutes = timeIn && timeOut ? Math.round((timeOut.getTime() - timeIn.getTime()) / 60000) : null;

	return (
		<div className="grid grid-cols-1 gap-6 md:grid-cols-2">
			<div className="rounded-lg border border-slate-200 bg-white p-4">
				<label className="mb-2 block text-sm font-medium text-slate-700">Time In</label>
				<div className="flex items-center gap-2 text-slate-900">
					<Clock className="size-5 text-green-600" />
					<span className="font-semibold">{timeIn.toLocaleString()}</span>
				</div>
				<p className="mt-1 text-xs text-slate-500">Automatically recorded when visit started</p>
			</div>

			<div className="rounded-lg border border-slate-200 bg-white p-4">
				<label className="mb-2 block text-sm font-medium text-slate-700">Time Out</label>
				<div className="flex items-center gap-2 text-slate-900">
					<Clock className="size-5 text-red-600" />
					<span className="font-semibold">{timeOut ? timeOut.toLocaleString() : 'Visit in progress'}</span>
				</div>
				{timeOut ? (
					<p className="mt-1 text-xs text-slate-500">
						Visit ended at {timeOut.toLocaleString()} Duration: {visitLengthInMinutes} minutes
					</p>
				) : (
					<p className="mt-1 text-xs text-slate-500">Will be recorded when visit ends</p>
				)}
			</div>
		</div>
	);
}
